import { render, staticRenderFns } from "./GoodsDetail.vue?vue&type=template&id=0b9bda4f&scoped=true&"
import script from "./GoodsDetail.vue?vue&type=script&lang=js&"
export * from "./GoodsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9bda4f",
  null
  
)

export default component.exports